// extracted by mini-css-extract-plugin
export default {"quizStart":"start_quizStart__AvO0n"};